import React from 'react';
import { 
  ThemeProvider, 
  CssBaseline, 
  Box, 
  Container
} from '@mui/material';
import { SnackbarProvider } from 'notistack';
import Header from './components/Header';
import LinkConverter from './components/LinkConverter';
import theme from './styles/theme';

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider 
        maxSnack={3} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={3000}
      >
        <Box
          sx={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #003c71 0%, #0056a3 50%, #003c71 100%)',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `
                repeating-linear-gradient(
                  45deg,
                  transparent,
                  transparent 35px,
                  rgba(255, 196, 37, 0.03) 35px,
                  rgba(255, 196, 37, 0.03) 70px
                )
              `,
              pointerEvents: 'none',
              zIndex: 0
            }
          }}
        >
          <Container 
            maxWidth="md" 
            sx={{ 
              py: 4,
              position: 'relative',
              zIndex: 1
            }}
          >
            <Header />
            <LinkConverter />
          </Container>
        </Box>
      </SnackbarProvider>
    </ThemeProvider>
  );
}
